import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraLink, SpecraText } from '@mono/ui-components/ensigns';
import { SpecraBadgeSequence, SpecraEntityCell, SpecraKeyValueRow, SpecraSectionHeader } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { careerDateLabel } from '../contact/careerDateLabel';
export function PeopleInOut({ people }) {
    return /*#__PURE__*/ _jsxs("section", {
        className: "space-y-3",
        children: [
            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                variant: "group",
                title: "People · who's here, who left, where they went",
                action: /*#__PURE__*/ _jsx(SpecraText, {
                    size: "meta",
                    tone: "muted",
                    children: "Registry people · each move sourced"
                })
            }),
            people.length === 0 && /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                size: "body-ui",
                tone: "muted",
                children: "No people recorded at this office yet."
            }),
            people.map((p)=>/*#__PURE__*/ _jsx(SpecraKeyValueRow, {
                    "data-testid": Testids.registryGovOrg.personRow,
                    label: /*#__PURE__*/ _jsx(SpecraEntityCell, {
                        title: /*#__PURE__*/ _jsx(SpecraLink, {
                            href: `/registries/contacts/${encodeURIComponent(p.contactId)}`,
                            renderLink: renderRouterLink,
                            children: p.name
                        }),
                        description: /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                p.hereStatus === 'PAST' ? 'Previously here' : 'Here now',
                                p.source?.text && ` · ${p.source.text}`,
                                p.moveNote && ` · ${p.moveNote}`
                            ]
                        })
                    }),
                    value: /*#__PURE__*/ _jsx(SpecraBadgeSequence, {
                        label: `Career path of ${p.name}`,
                        "data-testid": Testids.registryGovOrg.careerPath,
                        separator: "arrow",
                        align: "end",
                        items: p.employments.slice(-3).map((e, i)=>({
                                id: e.employmentId || `form-${i}`,
                                label: /*#__PURE__*/ _jsxs("span", {
                                    children: [
                                        e.title || 'Role not recorded',
                                        ",",
                                        ' ',
                                        e.employer?.name || e.employerText || 'Employer not recorded',
                                        " ·",
                                        ' ',
                                        careerDateLabel({
                                            dateBasis: e.dateBasis,
                                            startDate: e.startDate?.toDate() ?? null,
                                            endDate: e.endDate?.toDate() ?? null,
                                            observedFrom: e.observedFrom?.toDate() ?? null,
                                            observedTo: e.observedTo?.toDate() ?? null
                                        }),
                                        e.departureDestinationText && ` · ${e.departureDestinationText}`,
                                        e.source?.text && /*#__PURE__*/ _jsxs(SpecraText, {
                                            as: "span",
                                            size: "meta",
                                            tone: "muted",
                                            children: [
                                                ' ',
                                                "· ",
                                                e.source.text
                                            ]
                                        })
                                    ]
                                }),
                                variant: e.sector === 'OURS' ? 'success' : e.sector === 'INDUSTRY' ? 'info' : 'neutral'
                            }))
                    })
                }, p.contactId))
        ]
    });
}
